import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';
import { OrderGridCollectionQuery, OrderGridCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(OrderGridCollectionQuery)
@Wrapper(OrderGridCollectionQueryHandlerBase)
export class OrderCollectionQueryHandler {
    public constructor(
        http: Http,
        rootContext: RootContext
    ) { }
}